import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { MeduskladisnicaService } from '../pages/meduskladisnica/meduskladisnica.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaMeduskladisniceService {

  stavke: any = [];

  constructor(private service: MeduskladisnicaService, private authService: AuthService) {}

  //PDF-a MEĐUSKLADIŠNICA - izlaz
  pdfMeduskladisnica(data) {
    //console.log('DATA: ', data);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    this.service.pregledDokumenataStavke({ pz_id: data.data.pz_id }).subscribe((res) => {
      //console.log('res: ', res);
      if (res.success == true) {

        let ct = [];

        ct.push({
          columns: [
            {
              
            },

            {
              table: {
                widths: ['*'],
                heights: [95],
                body: [
                  [
                    {
                      table: {
                        body: [
                          [
                            {
                              text: 'PEKAR d.o.o.',
                              style: 'title',
                            },
                          ],
                          [
                            {
                              text: 'Obrtnička ulica 5',
                              style: 'subtitle',
                            },
                          ],
                          [
                            {
                              text: 'Vinkovci',
                              style: 'subtitle',
                            },
                          ],
                          [
                            {
                              text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030084282, OIB: 67289965400. Temeljni kapital 5.384.400,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Raiffeisen Bank 2484008-1106129914   IBAN: HR4024840081106129914 Ž.r. Otp bank 2407000-1100629330 IBAN: HR4024070001100629330 SWIFT: OTPVHR2X',
                              style: 'details',
                            },
                          ],
                        ],
                      },
                      layout: 'noBorders',
                    },
                  ],
                ],
              },
            },
          ],
        });

        ct.push({
          text: '\n' + '\n',
        });

        ct.push({
          columns: [
            {
              table: {
                widths: ['*'],
                heights: [70],
                body: [
                  [
                    {
                      text:
                        `Skladište otpreme: ${data.data.sifrainaziv || ''}
                        Skladište prijema: ${data.data.sifrainaziv2 || ''}, Interna primka: ${data.data.pz_brojvezni || ''}
                        Za partnera: ${data.data.za_partnera || ''}
                        Adresa isporuke: ${data.data.ardesa_isporuke || ''}
                        `,
                      style: 'subtitle',
                    } 
                  ] 
                ]
              },
            }
          ],
        });

        ct.push({
          text: '\n' + '\n',
        });

        ct.push({
          text:
            'Međuskladišnica: ' +
            data.data.po_sifra +
            '-' +
            data.data.pz_broj +
            '/' +
            moment(data.data.pz_datum).format('YYYY'),
          style: 'mainTitle',
          alignment: 'center',
          margin: [0, 0, 0, 0],
        });

        ct.push({
          text: '\n',
        });

        ct.push({
          text: 'Datum:' + moment(data.data.pz_datum).format('DD.MM.YYYY'),
        });

        ct.push({
          text: '\n' + '\n',
        });

        let brojac = 1;
        let ukupnoKolicina = 0;
        let ukupnoIznos = 0;
        let ukupnoMaloprodajnavrijednost = 0;
        let ukupnaTezinaAmbalaze = 0;

        this.stavke = res.prometstavke;
        let arr = res.prometstavke;
        let kartoni = res.kartoni;
        let result = arr.reduce(function (r, a) {
          r[a.ar_lot] = r[a.ar_lot] || [];
          r[a.ar_lot].push(a);
          return r;
        }, Object.create(null));
        //console.log(result);

        kartoni.forEach(karton => {
          //console.log(kartoni)
          ukupnaTezinaAmbalaze += karton.ukupna_tezina_ambalaze
        });

        ct.push(hLine);
        ct.push({
          table: {
            //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Izlazna cijena Porez % Iznos
            widths: [10, 28, 55, 100, 20, 35, 28, 28, 30, 25, 32],
            body: [
              [
                'Rb',
                'Šifra' + '\n' + 'LOT',
                'EAN kod' + '\n' + 'Rok trajanja',
                'Naziv artikla',
                'Jed. mjere',
                'Količina',
                'Izlazna cijena',
                'Porez %',
                'Iznos',
                'Malopr.' + '\n' + 'cijena',
                'Malopr.' + '\n' + 'vrijed.',
              ],
            ],
          },
          layout: 'lightHorizontalLines',
        });

        ct.push(hLine);
        for (let lot in result) {
          let stavkaSifra = '';
          let stavkaEanKod = '';
          let stavkaNaziv = '';
          let stavkaJedMjere = '';
          let stavkaKolicina = 0;
          let stavkaIzlaznaCijena = 0;
          let stavkaPorez = 0;
          let stavkaIznos = 0;
          let stavkaMaloprodajnacijena = 0;
          let stavkaMaloprodajnavrijednost = 0;

          //console.log('RESULT ', result);
          //console.log('LOT: ', lot);


          for (let stavka of result[lot]) {
            //console.log('STAVKA: ', stavka);
            //console.log('result[lot]: ', result[lot]);

            stavkaSifra = (stavka.ar_sifra + '\n' + stavka.ar_lot) || '/';
            stavkaEanKod = (stavka.bk_kod + '\n' + ((stavka.ps_vazido != null ? moment(stavka.ps_vazido).format('DD.MM.YYYY') : moment(stavka.vazi_do_rnalog).format('DD.MM.YYYY'))));
            stavkaNaziv = stavka.ar_naziv || '/';
            stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA || '/';
            stavkaKolicina = stavka.ps_izlaz || '/';
            stavkaIzlaznaCijena = stavka.ps_izlazc || 0;
            stavkaPorez = stavka.pz_posto;
            stavkaIznos = stavka.ps_izlazvr;
            stavkaMaloprodajnacijena = stavka.ps_maloprodcijena;
            stavkaMaloprodajnavrijednost = (stavka.ps_maloprodcijena * stavka.ps_izlaz);

            ukupnoKolicina += stavka.ps_izlaz;
            ukupnoIznos += stavkaIznos;
            ukupnoMaloprodajnavrijednost += stavkaMaloprodajnavrijednost;
          }

          ct.push({
            table: {
              //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Izlazna cijena Porez % Iznos
              widths: [10, 28, 55, 100, 20, 35, 28, 28, 30, 25, 32],
              body: [
                [
                  brojac++,
                  stavkaSifra,
                  stavkaEanKod,
                  stavkaNaziv,
                  stavkaJedMjere,
                  { text: this.formatiraj(stavkaKolicina, 2), alignment: 'right'},
                  { text: this.formatiraj(stavkaIzlaznaCijena, 3), alignment: 'right' },
                  { text: stavkaPorez + '%', alignment: 'right' },
                  { text: this.formatiraj(stavkaIznos, 2), alignment: 'right' },
                  { text: this.formatiraj(stavkaMaloprodajnacijena, 3), alignment: 'right' },
                  { text: this.formatiraj(stavkaMaloprodajnavrijednost, 2), alignment: 'right' },
                ],
              ],
            },
            layout: 'lightHorizontalLines',
          });
        }

        //UKUPNO
        ct.push(hLine);
        ct.push({
          table: {
            widths: [280, 40, 40, 30, 40, 30, 42],
            body: [
              [
                {
                  text: 'UKUPNO',
                  style: 'tableFooter',
                  margin: [5, 0, 0, 0],
                },
                { text: this.formatiraj(ukupnoKolicina, 2), alignment: 'right', style: 'tableFooter' },
                { text:  '', alignment: 'right', style: 'tableFooter' },
                { text:  '', alignment: 'right', style: 'tableFooter' },
                { text: this.formatiraj(ukupnoIznos, 2), alignment: 'right', style: 'tableFooter' },
                { text:  '', alignment: 'right', style: 'tableFooter' },
                { text: this.formatiraj(ukupnoMaloprodajnavrijednost, 2), alignment: 'right', style: 'tableFooter' },
              ],
            ],
          },
          layout: 'noBorders',
        });

        const rekapitulacijaPoreza = this.izracunajRekapitulaciju(this.stavke);

        ct.push({
          text: '\n\n'
        })

        ct.push({
          table: {
            headerRows: 1,
            widths: ['*',100, 'auto', 'auto', 'auto'],
            body: [
              [
                {text: '', border: [false, false, false, false]},
                {text: 'Rekapitulacija poreza', border: [false, false, false, true]},
                {text: '% poreza', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}, 
                {text: 'Osnovica', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}, 
                {text: 'Iznos poreza', alignment: 'right', margin: [0, 0, 10, 0], border: [false, false, false, true]}
              ],
              ...rekapitulacijaPoreza.map(stavka => [{text: '', border: [false, false, false, false]},{text: '', border: [false, false, false, false]}, {text: stavka.stopa + '%', alignment: 'right', border: [false, false, false, false]}, {text: this.formatiraj(stavka.osnovica, 2), alignment: 'right', border: [false, false, false, false]}, {text: this.formatiraj(stavka.iznosPoreza, 2), alignment: 'right', border: [false, false, false, false]},]),          
              [
                { text: '', border: [false, false, false, false]},
                { text: 'Ukupno', bold: true, border: [false, true, false, false]},
                { text: '', border: [false, true, false, false]},
                { text: '', bold: true, alignment: 'right', border: [false, true, false, false]},
                { text: this.formatiraj(rekapitulacijaPoreza.reduce((sum, item) => sum + parseFloat(item.ukupanIznos), 0), 2) + ' EUR', bold: true, alignment: 'right', border: [false, true, false, false], style: 'ufaFooter'}
              ]
            ]
          }, 
        });

        ct.push({
          text: '\n' + '\n',
        });

        ct.push({
          columns: [
            {
              table: {
                widths: ['*'],
                body: [
                  [
                    {
                      text: 'Napomena: ' , decoration: 'underline', bold: true,
                    },
                  ],
                  [
                    {
                      text: data.data.pz_napomena
                    },
                  ],
                ],
              },
              layout: 'noBorders',
            },
          ],
        });

        var dd = {
          info: {
            title: 'Međuskladišnica: ' + data.data.pz_id,
          },
          content: ct,
          pageMargins: 20,
          defaultStyle: {
            fontSize: 7.5,
          },
          styles: {
            title: {
              fontSize: 12,
              bold: true,
            },
            subtitle: {
              fontSize: 10,
            },
            details: {
              fontSize: 6,
            },
            tableTitle: {
              fontSize: 8,
              bold: true,
            },
            mainTitle: {
              fontSize: 17,
              bold: true,
            },
            tableFooter: {
              bold: true,
            },
          },
        };

        pdfMake.createPdf(dd).open();
      } else {
        notify(
          'Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovo.',
          'warning',
          3000
        );
      }
    });
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }

  izracunajRekapitulaciju(stavke) {
    const porezi = {};

    if(stavke) {
      stavke.forEach(stavka => {
        const osnovica = stavka.ps_izlazvr;
        const porez = osnovica * stavka.pz_posto / 100;

        if(!porezi[stavka.pz_posto]) {
          porezi[stavka.pz_posto] = { osnovica: 0, porez: 0};
        }

        porezi[stavka.pz_posto].osnovica += osnovica;
        porezi[stavka.pz_posto].porez += porez;
      });

      return Object.keys(porezi).map(key => ({
        stopa: key,
        ukupanIznos: porezi[key].osnovica + porezi[key].porez,
        osnovica: porezi[key].osnovica.toFixed(2),
        iznosPoreza: porezi[key].porez.toFixed(2),
      }));
    }
  }
}
